// deviceName.ts
// ───────────────────────────────────────────────────────────────────────────
// Nombre automático de la passkey de un dispositivo: «Chrome en Mac»,
// «Safari en iPhone»… Se arma del user agent y alcanza para que la persona
// reconozca cuál es cuál en /settings/security. No es un identificador:
// dos navegadores iguales en equipos distintos se llaman igual.
// ───────────────────────────────────────────────────────────────────────────

export function nombreDeNavegador(ua: string): string {
  // El orden importa: Edge y Opera dicen "Chrome", y Chrome dice "Safari".
  if (/Edg(e|A|iOS)?\//.test(ua)) return 'Edge';
  if (/OPR\/|Opera/.test(ua)) return 'Opera';
  if (/Firefox\/|FxiOS\//.test(ua)) return 'Firefox';
  if (/Chrome\/|CriOS\//.test(ua)) return 'Chrome';
  if (/Safari\//.test(ua)) return 'Safari';
  return 'Navegador';
}

export function nombreDeSistema(ua: string): string {
  // iPad/iPhone antes que Mac: el user agent de iOS también dice "like Mac OS X".
  if (/iPhone/.test(ua)) return 'iPhone';
  if (/iPad/.test(ua)) return 'iPad';
  if (/Android/.test(ua)) return 'Android';
  if (/Windows/.test(ua)) return 'Windows';
  if (/Mac OS X|Macintosh/.test(ua)) return 'Mac';
  if (/CrOS/.test(ua)) return 'Chromebook';
  if (/Linux/.test(ua)) return 'Linux';
  return 'este dispositivo';
}

export function nombreDeDispositivo(ua: string = globalThis.navigator?.userAgent ?? ''): string {
  return `${nombreDeNavegador(ua)} en ${nombreDeSistema(ua)}`;
}
